import React, { useState, useEffect } from 'react';
import './App.css';
import { getApiUrl } from './apiConfig';

const fallbackCenters = [
    {
        id: "rajawaka",
        name: "සේවා සංස්කරණ අභ්‍යාස ආයතනය-ගොඩකුඹුර,රජවක",
        categories: [
            {
                id: 1,
                label: 'පැළ',
                options: [
                    { id: 101, label: 'ගම්මිරිස් පැළ' },
                    { id: 102, label: 'එළවළු පැළ' }
                ]
            },
            {
                id: 2,
                label: 'බද්ධ පැළ',
                options: [
                    { id: 201, label: 'බද්ධ අඹ පැළ' },
                    { id: 202, label: 'බද්ධ කොස් පැළ' },
                    { id: 203, label: 'බද්ධ අලිපේර පැළ' },
                    { id: 204, label: 'බද්ධ කාමරංගා පැළ' },
                    { id: 205, label: 'බද්ධ ගොරකා පැළ' }
                ]
            },
            {
                id: 3,
                label: 'අතු පැළ',
                options: [
                    { id: 301, label: 'ගම්මිරිස් අතු පැළ' },
                    { id: 302, label: 'වෙරළු අතු පැළ' },
                    { id: 303, label: 'දෙහි අතු පැළ' },
                    { id: 304, label: 'දෙළුම් අතු පැළ' }
                ]
            },
            {
                id: 4,
                label: 'බීජ පැළ',
                options: [
                    { id: 401, label: 'පේර බීජ පැළ' },
                    { id: 402, label: 'මිටි අඹරැල්ල බීජ පැළ' },
                    { id: 403, label: 'දෙහි බීජ පැළ' },
                    { id: 404, label: 'දෙළුම් බීජ පැළ' },
                    { id: 405, label: 'ගොරකා බීජ පැළ' },
                    { id: 406, label: 'නෙල්ලි බීජ පැළ' }
                ]
            }
        ]
    },
    {
        id: "karapincha",
        name: "දිස්ත්‍රික් කෘෂිකර්ම පුහුණු මධ්‍යස්ථානය-කරපිංච,කුරුවිට",
        categories: [
            {
                id: 1,
                label: 'අධි ශ්‍රේණියේ පැළ',
                options: [
                    { id: 101, label: 'අධි ශ්‍රේණියේ දූරියන් පැළ' },
                    { id: 102, label: 'අධි ශ්‍රේණියේ රඹුටන් පැළ' },
                    { id: 103, label: 'අධි ශ්‍රේණියේ අඹ පැළ' }
                ]
            },
            {
                id: 2,
                label: 'බද්ධ පැළ',
                options: [
                    { id: 201, label: 'බද්ධ දූරියන් පැළ' },
                    { id: 202, label: 'බද්ධ රඹුටන් පැළ' },
                    { id: 203, label: 'බද්ධ අඹ පැළ' },
                    { id: 204, label: 'බද්ධ කොස් පැළ' },
                    { id: 205, label: 'බද්ධ අලිපේර පැළ' },
                    { id: 206, label: 'බද්ධ නාරං පැළ' },
                    { id: 207, label: 'බද්ධ දොඩම් පැළ' },
                    { id: 208, label: 'බද්ධ දෙහි පැළ' }
                ]
            },
            {
                id: 3,
                label: 'පටක රෝපිත පැළ',
                options: [
                    { id: 301, label: 'පටක රෝපිත අන්නාසි පැළ' },
                    { id: 302, label: 'පටක රෝපිත කෙසෙල් පැළ' },
                    { id: 303, label: 'පටක රෝපිත තැඹිලි පැළ' },
                    { id: 304, label: 'පටක රෝපිත පොල් පැළ' }
                ]
            },
            {
                id: 4,
                label: 'බීජ පැළ',
                options: [
                    { id: 401, label: 'අනෝදා බීජ පැළ' },
                    { id: 402, label: 'පේර බීජ පැළ' },
                    { id: 403, label: 'පැෂන් බීජ පැළ' }
                ]
            },
            {
                id: 5,
                label: 'අතු පැළ',
                options: [
                    { id: 501, label: 'වෙරළු අතු පැළ' },
                    { id: 502, label: 'ලෙමන් අතු පැළ' },
                    { id: 503, label: 'ජම්බු අතු පැළ' },
                    { id: 504, label: 'මිරකල් බෙලි අතු පැළ' },
                    { id: 505, label: 'දෙහි අතු පැළ' },
                    { id: 506, label: 'බෙලි අතු පැළ' }
                ]
            },
            {
                id: 6,
                label: 'අස්වනු නිෂ්පාදන',
                options: [
                    { id: 601, label: 'කොම්පෝස්ට් පොහොර' },
                    { id: 602, label: 'එළවළු වර්ග' },
                    { id: 603, label: 'කෙසෙල්' },
                    { id: 604, label: 'අන්නාසි' },
                    { id: 605, label: 'පොල්' },
                    { id: 606, label: 'පැෂන්' },
                    { id: 607, label: 'රඹුටන්' }
                ]
            }
        ]
    },
    {
        id: "embilipitiya",
        name: "කෘෂි ව්‍යවසායකත්ව කේන්ද්‍රය - ඇඹිළිපිටිය",
        categories: [
            {
                id: 1,
                label: 'පැළ සහ බීජ',
                options: [
                    { id: 101, label: 'උසස් තත්ත්වයේ එළවළු බීජ' },
                    { id: 102, label: 'පළතුරු පැළ වර්ග' }
                ]
            },
            {
                id: 2,
                label: 'අස්වනු සහ වෙනත් නිෂ්පාදන',
                options: [
                    { id: 201, label: 'කාබනික පොහොර' },
                    { id: 202, label: 'නැවුම් ගොවිපළ එළවළු' }
                ]
            }
        ]
    },
    {
        id: "wagolla",
        name: "දිස්ත්‍රික් කෘෂිකර්ම පුහුණු මධ්‍යස්ථානය-වාගොල්ල,රඹුක්කන",
        categories: [
            {
                id: 1,
                label: 'බද්ධ පලතුරු පැළ',
                options: [
                    { id: 101, label: 'බද්ධ අඹ පැළ' },
                    { id: 102, label: 'බද්ධ රඹුටන් පැළ' },
                    { id: 103, label: 'බද්ධ දූරියන් පැළ' }
                ]
            },
            {
                id: 2,
                label: 'පලතුරු බීජ පැළ',
                options: [
                    { id: 201, label: 'පේර බීජ පැළ' },
                    { id: 202, label: 'අනෝදා බීජ පැළ' }
                ]
            },
            {
                id: 3,
                label: 'පලතුරු අතු පැළ',
                options: [
                    { id: 301, label: 'දෙහි අතු පැළ' },
                    { id: 302, label: 'ජම්බු අතු පැළ' }
                ]
            },
            {
                id: 4,
                label: 'එළවළු පැළ',
                options: [
                    { id: 401, label: 'මිරිස් පැළ' },
                    { id: 402, label: 'තක්කාලි පැළ' },
                    { id: 403, label: 'බටු පැළ' }
                ]
            }
        ]
    },
    {
        id: "beminiwatta",
        name: "රජයේ මධ්‍යම පැල තවාන-බැමිණිවත්ත,මාවනැල්ල",
        categories: [
            {
                id: 1,
                label: 'බද්ධ පැළ',
                options: [
                    { id: 101, label: 'බද්ධ දූරියන් පැළ' },
                    { id: 102, label: 'බද්ධ රඹුටන් පැළ' },
                    { id: 103, label: 'බද්ධ අඹ පැළ' },
                    { id: 104, label: 'බද්ධ කොස් පැළ' }
                ]
            },
            {
                id: 2,
                label: 'පැළ',
                options: [
                    { id: 201, label: 'ගම්මිරිස් පැළ' },
                    { id: 202, label: 'එලවළු පැළ' }
                ]
            },
            {
                id: 3,
                label: 'අතු පැළ',
                options: [
                    { id: 301, label: 'ලෙමන් අතු පැළ' }
                ]
            },
            {
                id: 4,
                label: 'බීජ පැළ',
                options: [
                    { id: 401, label: 'පේර බීජ පැළ' },
                    { id: 402, label: 'මිටි අඹරැල්ල බීජ පැළ' },
                    { id: 403, label: 'පැපොල් බීජ පැළ' }
                ]
            },
            {
                id: 5,
                label: 'අස්වනු නිෂ්පාදන',
                options: [
                    { id: 501, label: 'අල වර්ග' },
                    { id: 502, label: 'එළවළු වර්ග' },
                    { id: 503, label: 'කෙසෙල්' },
                    { id: 504, label: 'බිම්මල් පැකට්' },
                    { id: 505, label: 'පොල්' },
                    { id: 506, label: 'රඹුටන්' }
                ]
            }
        ]
    },
    {
        id: "marukwathura",
        name: "රජයේ ගොවිපළ-මාරුක්වතුර,රඹුක්කන",
        categories: [
            {
                id: 1,
                label: 'අස්වනු නිෂ්පාදන',
                options: [
                    { id: 101, label: 'පොල් අස්වැන්න' },
                    { id: 102, label: 'කාබනික පොහොර' },
                    { id: 103, label: 'කර දහයියා' }
                ]
            }
        ]
    },
    {
        id: "bimmal",
        name: "බිම්මල් බීජ මධ්‍යස්ථානය-වාගොල්ල,රඹුක්කන",
        categories: [
            {
                id: 1,
                label: 'බිම්මල් නිෂ්පාදන',
                options: [
                    { id: 101, label: 'බිම්මල් බීජ (Mushroom Spawn)' },
                    { id: 102, label: 'නැවුම් ඇමරිකන් ඔයිස්ටර් බිම්මල්' },
                    { id: 103, label: 'බූටාන් බිම්මල්' }
                ]
            }
        ]
    },
    {
        id: "pataka",
        name: "පටක රෝපණ විද්‍යාගාරය-වාගොල්ල,රඹුක්කන",
        categories: [
            {
                id: 1,
                label: 'පටක රෝපිත පැළ',
                options: [
                    { id: 101, label: 'පටක රෝපිත කෙසෙල් පැළ (ඇඹුල් / කෝලිකුට්ටු)' },
                    { id: 102, label: 'පටක රෝපිත අන්නාසි පැළ' },
                    { id: 103, label: 'පටක රෝපිත ඕකිඩ් පැළ' }
                ]
            }
        ]
    }
];

export default function FarmProducts({ onBackClick }) {
    const [view, setView] = useState('centers'); // 'centers' or center ID / '<center>-options'
    const [expandedCard, setExpandedCard] = useState(null); // id of expanded category card
    const [centersData, setCentersData] = useState(() => {
        try {
            const local = localStorage.getItem('site_farm_products');
            if (local) {
                const parsed = JSON.parse(local);
                if (Array.isArray(parsed) && parsed.length > 0) return parsed;
            }
        } catch (e) {}
        return fallbackCenters;
    });

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const res = await fetch(getApiUrl(`api_farm_products.php?t=${Date.now()}`));
                if (res.ok) {
                    const data = await res.json();
                    if (Array.isArray(data) && data.length > 0) {
                        setCentersData(data);
                        try { localStorage.setItem('site_farm_products', JSON.stringify(data)); } catch (e) {}
                        return;
                    }
                }
                throw new Error('API fetch failed');
            } catch (err) {
                try {
                    const staticRes = await fetch(`/farm_products_data.json?t=${Date.now()}`);
                    if (staticRes.ok) {
                        const staticData = await staticRes.json();
                        if (Array.isArray(staticData) && staticData.length > 0) {
                            setCentersData(staticData);
                        }
                    }
                } catch (staticErr) {}
            }
        };

        fetchProducts();
    }, []);

    const handleBack = () => {
        if (expandedCard !== null) {
            setExpandedCard(null);
        } else if (view !== 'centers') {
            setView('centers');
        } else if (onBackClick) {
            onBackClick('home');
        }
    };

    // Find current center object
    const cleanViewId = view.replace('-options', '');
    const currentCenter = centersData.find(c => c.id === view || c.id === cleanViewId);

    const getCenterTitle = () => {
        if (view === 'centers') return 'ගොවිපල නිෂ්පාදන';
        if (currentCenter) {
            return currentCenter.name.includes('නිෂ්පාදන') 
                ? currentCenter.name 
                : `${currentCenter.name} - නිෂ්පාදන`;
        }
        return 'ගොවිපල නිෂ්පාදන';
    };

    const currentCategories = currentCenter?.categories || [];

    return (
        <section className="agripaper-section" aria-label="Farm Products">
            <div className="agripaper-header">
                <button
                    className="back-button"
                    onClick={handleBack}
                    style={{
                        backgroundColor: '#0b6b2f',
                        color: 'white',
                        border: 'none',
                        padding: '8px 16px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        marginBottom: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                    }}
                    aria-label="back"
                >
                    ← ආපසු
                </button>
                <h1 className="about-overview-title" style={{ color: '#0b6b2f', fontSize: 28, marginBottom: 12, textAlign: 'justify' }}>
                    {getCenterTitle()}
                </h1>
                <hr className="footer-sep" />
            </div>

            {view === 'centers' ? (
                <div className="farm-centers-grid">
                    {centersData.map(center => (
                        <div
                            key={center.id}
                            className="center-card"
                            onClick={() => {
                                setView(center.id);
                                setExpandedCard(null);
                            }}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="center-card-text">
                                {center.name}
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="farm-centers-grid" style={{ marginTop: '40px', alignItems: 'flex-start' }}>
                    {currentCategories.length === 0 ? (
                        <div style={{ textAlign: 'center', gridColumn: '1 / -1', padding: '40px', color: '#64748b', background: '#fff', borderRadius: '12px' }}>
                            දැනට මෙම මධ්‍යස්ථානය සඳහා නිෂ්පාදන ඇතුලත් කර නොමැත.
                        </div>
                    ) : (
                        currentCategories.map(btn => (
                            <div
                                key={btn.id}
                                className="center-card"
                                style={{
                                    padding: '0',
                                    minHeight: 'auto',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    cursor: btn.options && btn.options.length > 0 ? 'pointer' : 'default'
                                }}
                                onClick={() => btn.options && btn.options.length > 0 && setExpandedCard(expandedCard === btn.id ? null : btn.id)}
                            >
                                <div
                                    style={{
                                        padding: '30px 20px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}
                                >
                                    <div className="center-card-text" style={{ fontSize: '20px', margin: 0 }}>
                                        {btn.label}
                                    </div>
                                    {btn.options && btn.options.length > 0 && (
                                        <span style={{
                                            transition: 'transform 0.3s ease',
                                            transform: expandedCard === btn.id ? 'rotate(180deg)' : 'rotate(0deg)',
                                            fontSize: '24px',
                                            color: '#0b6b2f'
                                        }}>
                                            ▾
                                        </span>
                                    )}
                                </div>

                                {btn.options && btn.options.length > 0 && expandedCard === btn.id && (
                                    <div style={{
                                        backgroundColor: '#f9f9f9',
                                        borderTop: '1px solid #eee',
                                        padding: '10px 0'
                                    }}>
                                        {btn.options.map(opt => (
                                            <div
                                                key={opt.id}
                                                style={{
                                                    padding: '12px 20px',
                                                    borderBottom: '1px solid #f0f0f0',
                                                    color: '#333',
                                                    fontSize: '20px',
                                                    textAlign: 'left',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px'
                                                }}
                                            >
                                                <span style={{ color: '#0b6b2f' }}>•</span> {opt.label}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))
                    )}
                </div>
            )}

            {view !== 'centers' && (
                <div className="farm-notice">
                    <span className="notice-icon">ⓘ</span>
                    <p style={{ fontSize: '22px' }}>
                        ගොවිපළ නිෂ්පාදන මිල දී ගැනීමට අවශ්‍ය නම්, ප්‍රථමව එම ආයතනය හා සම්බන්ධ වී තොරතුරු ලබා ගැනීමට කාරුණික වන්න.
                    </p>
                </div>
            )}
        </section>
    );
}
